import { ERRORS_FOR_ACTION } from "../constants";

export const SAVE_TYPE = {
    SCHEDULE: 1,
    NON_BUSINESS_DAY: 2
};
export const SCHEDULE_ERROR_TEXTS = {
    START_DATE_IS_GREATER_THAN_END_DATE: "La hora de inicio es mayor o igual a la de fin."
};
export const GET_DIALOG_SAVE_PROPS = {
    [SAVE_TYPE.SCHEDULE]: () => ({
        title: "¿Deseas registrar este Horario de atención?",
        content: "Recuerda que al registrar dicho Horario de atención, quedará habilitado para cualquier reserva.",
    }),
    [SAVE_TYPE.NON_BUSINESS_DAY]: formattedDate => ({
        title: `¿Deseas registrar el ${formattedDate} como Día no hábil?`,
        content: "Recuerda que al registrar dicho día como Día no hábil, quedará deshabilitado para cualquier reserva."
    })
};
export const GET_DIALOG_DELETE_PROPS = {
    [SAVE_TYPE.SCHEDULE]: dayName => ({
        title: `¿Deseas eliminar el Horario de atención del día ${dayName}?`,
        content: "Recuerda que desaparecerá del listado y deberás registrarlo nuevamente.",
    }),
    [SAVE_TYPE.NON_BUSINESS_DAY]: formattedDate => ({
        title: `¿Deseas eliminar el ${formattedDate} como Día no hábil?`,
        content: "Recuerda que desaparecerá del listado y deberás registrarlo nuevamente."
    })
};
export const GET_DIALOG_ERROR_NOTIFICATION_PROPS = {
    [ERRORS_FOR_ACTION.SCHEDULES_REGISTER.REGISTERED_PREV]: days => {
        if (days.length === 1)  
            return {
                title: `No se puede registrar el Horario de atención del día ${days[0]}`,
                content: "Recuerda que para poder registrar un Horario de atención, no debe existir un registro previo del mismo día.",
            };
        return {
            title: "No se pueden registrar los horarios de atención de estos días", 
            content: <>
                <ul className="list">{days.map((day, idx) => <li key={idx}>{day}</li>)}</ul>
                <p className="paragraph center">
                    <br/>
                    Recuerda que para poder registrar un Horario de atención, no debe existir un registro previo del mismo día.
                </p>
            </>
        };
    },
    [ERRORS_FOR_ACTION.SCHEDULES_DELETION.EXIST_RESERVATIONS]: dayName => ({
        title: `No se puede eliminar el horario de atención del día ${dayName}`,
        content: "Recuerda que para eliminar un registro de horario de atención, no debe existir ninguna reserva para ese día."
    }),
    [ERRORS_FOR_ACTION.NON_BUSINESS_DAY_REGISTER.REGISTERED_PREV]: () => ({
        title: "No se puede registrar este día como día no hábil",
        content: "Recuerda que para poder registrar un día no hábil, dicho no debe haberse registrado previamente.",
    })
};